(function (root, factory) {
  var config = factory();
  var target = /** @type {{ NormaConfig?: unknown }} */ (root);

  if (typeof module === 'object' && module.exports) {
    module.exports = config;
  }

  target.NormaConfig = config;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  return {
    STATUSES: ['In force', 'In process', 'Planned'],
    STATUS_CLASS_MAP: {
      'In force': 'inforce',
      'In process': 'inprocess',
      Planned: 'planned'
    },
    SUPABASE_URL: 'https://bvofbtvxgwzhqjstitij.supabase.co'
  };
});
